import { render, staticRenderFns } from "./datosDispositivo.vue?vue&type=template&id=1b59ff64&"
import script from "./datosDispositivo.vue?vue&type=script&lang=js&"
export * from "./datosDispositivo.vue?vue&type=script&lang=js&"
import style0 from "./datosDispositivo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
